import React from "react";
import PropTypes from "prop-types";
import Component from "components/component";

export default class CustomRequestOption extends Component {
  static propTypes = {
    id: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.state = { isOpen: false };
  }

  toggleOpen = e => {
    e.preventDefault();
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    const isOpen = this.state.isOpen;
    const { id, onChange, value } = this.props;
    const requestPlaceholder =
      "Note: Submit your custom requests here. Any custom request(s) will require review by Dmitriy & Co before item can be purchased.";
    const input = (
      <textarea
        id="custom-requests-input"
        className="custom-requests-input"
        onChange={onChange}
        placeholder={requestPlaceholder}
        value={value}
      />
    );

    const toggleClass = isOpen ? "toggle-row open" : "toggle-row";

    return (
      <div className="product-option-container">
        <div className="mobile-only">
          <div className="product-options-row custom-requests-row">
            <div className="product-options-wrapper-mobile">
              <a href="#" className={toggleClass} onClick={this.toggleOpen} />

              <p className="option-name custom-requests">Custom Requests</p>

              {isOpen && input}

              {!isOpen &&
                value && <p className="custom-request-value">"{value}"</p>}
            </div>
          </div>
        </div>

        <div className="desktop-only">
          <div className="product-options-title-row">
            <p id={id} className="lined-title">
              <span>Custom Requests</span>
            </p>
          </div>

          <div className="custom-request-input-wrapper">
            <p className="custom-request-label">Please enter details here (optional)</p>
            {input}
            <p className="custom-request-helper-text">* Additional charges may apply</p>
          </div>
        </div>
      </div>
    );
  }
}
